/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import styled from "styled-components";
import { DecimalInput, DropDown2, Input2 } from "components";
import { useInput } from "hooks";
import { ALL_COUPON_TYPES_PREDICTIVE_TEXT } from "config";
export const OfferPurchaseQtyValTextBuilder = ({
  className,
  value,
  onChange = () => {},
}) => {
  const start = useInput("2");
  const end = useInput("");
  const innerVal = useInput("10.00");
  const withCoupon = useInput("");

  const handleUpdateValue = (s, e, v, t) => {
    if (s && e) {
      onChange(`w/purchase/${s}-${e}/$${v}${t ? " w/" + t : ""}`);
    } else if (s) {
      onChange(`w/purchase/${s}/$${v}${t ? " w/" + t : ""}`);
    }
  };

  useEffect(() => {
    if (
      value &&
      value.startsWith("w/purchase/") &&
      value.slice(11).length > 0
    ) {
      // Split purchase part and coupon part (if any)
      const [purchasePart, couponPart] = value.split(" w/");

      //purchase parsing
      const main = purchasePart.slice(11);
      const splitIdx = main.indexOf("/$");
      const qtyRange = main.slice(0, splitIdx);
      innerVal.setValue(main.slice(splitIdx + 2));
      if (qtyRange.indexOf("-") > 0) {
        const qtyIdx = qtyRange.indexOf("-");
        start.setValue(qtyRange.slice(0, qtyIdx));
        end.setValue(qtyRange.slice(qtyIdx + 1));
      } else {
        start.setValue(qtyRange);
        end.setValue("");
      }

      // coupon_type extraction
      if (couponPart) {
        withCoupon.setValue(couponPart);
      } else {
        withCoupon.setValue("");
      }
    }
    return () => {};
  }, [value]);

  return (
    <div className={`${className} mt-1 p-2`}>
      <Title>Offer Text Builder</Title>
      <Container className="mt-2">
        <div className="mt-auto mb-1" style={{ fontSize: 13 }}>
          w/purchase/
        </div>
        <div style={{ width: 70, marginRight: 10, marginLeft: 10 }}>
          <Input2
            label="Qty. Start"
            value={start.value}
            type="float"
            onChange={(e) => {
              start.setValue(e);
              handleUpdateValue(e, end.value, innerVal.value, withCoupon.value);
            }}
          />
        </div>
        <div style={{ width: 70, marginRight: 10 }}>
          <Input2
            label="Qty. End"
            value={end.value}
            type="float"
            onChange={(e) => {
              end.setValue(e);
              handleUpdateValue(start.value, e, innerVal.value, withCoupon.value);
            }}
          />
        </div>

        <div className="ml-auto" style={{ width: 100 }}>
          <DecimalInput
            label="Value"
            value={innerVal.value}
            type="float"
            onChange={(e) => {
              innerVal.setValue(e);
              handleUpdateValue(start.value, end.value, e, withCoupon.value);
            }}
          />
        </div>
      </Container>

      <Container>
        <div className="mt-auto mb-1" style={{ fontSize: 13 }}>
          w/Coupon
        </div>
        <div style={{ width: 240, marginRight: 10, marginLeft: 10 }}>
          <DropDown2
            data={ALL_COUPON_TYPES_PREDICTIVE_TEXT}
            width={80}
            value={withCoupon.value}
            onChange={(e) => {
              withCoupon.setValue(e);
              handleUpdateValue(start.value, end.value, innerVal.value, e);
            }}
          />
        </div>
      </Container>
    </div>
  );
};

const Title = styled.div`
  color: #66c0e1;
  font-size: 16px;
`;
const Container = styled.div`
  background: ${(props) => props.theme.palette.items};
  padding: 8px;
  display: flex;
`;
